import { Error } from './Error';

export type { TypeErrorProps } from './types';
export default Error;
